import { ManageRunFlowTaskActions, userHasManageRunFlowTaskPermissions } from '~src/flow/utils/FlowTaskActionUtils';

import { Messages } from '../../../../codegen/Localize';
import { RunFlowTaskInfo } from '../../../../ts/models/RunFlowTaskInfo';
import { runFlowTaskChangeSchedule } from '../../../actions/spaces/RunFlowTaskMenuActions';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const RunFlowTaskChangeScheduleAction: IEntityAction<RunFlowTaskInfo, ManageRunFlowTaskActions> = {
  name: EntityActionNames.TasksChangeSchedule,
  translateName: Messages.changeSchedule_action,
  isVisible: (targetItems: RunFlowTaskInfo[], state: AppState) => {
    return targetItems.length > 0;
  },
  isClickable: (availableActions: ManageRunFlowTaskActions, targetItems: RunFlowTaskInfo[]) => {
    return userHasManageRunFlowTaskPermissions(availableActions);
  },
  createReduxAction: (targetItems: RunFlowTaskInfo[]) => runFlowTaskChangeSchedule(targetItems)
};
